import utils from '../../../utils';
import fetch from '../../fetch';

import { Modal, message } from 'antd';


const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 10
        },
        {
            key:'batchNo', 
            label: '批次号',
            width: 120
        },
        {
            key:'surveyName', 
            label: '问卷',
            width: 120
        },
        {
            key: 'objectName',
            label: '发布标识',
            width: 60
        },
        {
            key: 'currentTimes',
            label: '已填写的人数',
            width: 80
        },
        {
            key: 'limitedTimes',
            label: '最多可填写的人数',
            width: 110
        },
        {
            key: 'expiredDate',
            label: '截止时间',
            width: 60
        },
        {
            key: 'modelName',
            label: '人数限制'
        },
        {
            key: 'termName',
            label: '当前学期'
        }
    ]
)


const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                let sort = keywords[i];
                if (sort === 'modelName') {
                    sort = 'model';
                }
                params.push(`sort=${sort}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/common/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}


const queryPublishObject = () => {
    return fetch.get('platform/code/common/publish/object')
    .then(response => {
        return response.payload.data
    })
}


const publish = (keywords) => {
    return fetch.post('survey/common/publish', keywords)
    .then((response) => {
        if(response.code == 200) {
            Modal.success({
                title: '发布成功',
                content: '发布成功',
                onOk: () => {}
            })
            return response.payload.data;
        }
    })
}

const remove = (ids) => {
    return fetch.post('survey/common/delete', ids);
}

const get = (id) => {
    return fetch.get('survey/common/get/' + id)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data
        }
    })
}

const update = (data) => {
    return fetch.post('survey/common/update', data)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data
        }
    })
}

export default {
    columns,
    onSelect,
    onSelectData,
    setRefresh,
    querySearch,
    getSelection,
    remove,
    publish,
    update,
    queryPublishObject,
    get
}